export const lightTheme = {
  background: "#fff",
  color: "#121212",
  accentColor: "#3D84C6",
  chronoTheme: {
    cardBgColor: "white",
    cardForeColor: "black",
    titleColor: "black",
  },
  timelineLineColor: "#ccc",
  cardBackground: "#fff",
  cardFooterBackground: "#f7f7f7",
  cardBorderColor: "#00000020",
  navbarTheme: {
    linkColor: "#dedede",
    linkHoverColor: "#fefefe",
    linkActiveColor: "#fefefe",
  },
  bsPrimaryVariant: "light",
  bsSecondaryVariant: "dark",
  socialIconBgColor: "#121212",
};

export const darkTheme = {
  background: "#121212",
  color: "#eee",
  accentColor: "#3D84C6",
  chronoTheme: {
    cardBgColor: "#1B1B1B",
    cardForeColor: "#eee",
    titleColor: "white",
  },
  timelineLineColor: "#444",
  cardBackground: "#060606",
  cardFooterBackground: "#181818",
  cardBorderColor: "#ffffff20",
  navbarTheme: {
    linkColor: "#dedede",
    linkHoverColor: "#fefefe",
    linkActiveColor: "#fefefe",
  },
  bsPrimaryVariant: "dark",
  bsSecondaryVariant: "light",
  socialIconBgColor: "#fefefe",
};
